import React, { useEffect, useRef, useState } from "react";
import {
  minutesToHHMM,
  secondsToTime,
  timeToSeconds,
} from "../../../../Utilitie";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import BlockReportMaster from "../../BlockReportMaster";
import BlockPositionChart from "../../Block charts/Block Position/BlockPositionChart";
const tableHead = [
  "Block Demand",
  "Block Agreed",
  "Block Given",
  "Block Availed",
  "GIVEN %",

  "Burst",
  "Block Not Agreed",
  "Cases of BABNG",
];
const tableSubHead = [
  "No.of blocks",
  "Hours",
  "No.of blocks",
  "Hours",
  "No.of blocks",
  "Hours",
  "No.of blocks",
  "Hours",
  "No.of blocks %",
  "Hours %",
];
const BlockPositionMasterTable = ({ data, dataForTable }) => {
  const tableRef = useRef();
  const [finalData, setFinalData] = useState(null);
  useEffect(() => {
    if (data?.length > 0) {
      const groupedTotals = data.reduce((acc, item) => {
        if (!item.reportDate) return acc;

        const date = item.reportDate?.split("T")[0]; // keep only YYYY-MM-DD
        const num = (val) => Number(val) || 0;
        const text = (val) => (val || "").toString().toLowerCase();

        if (!acc[date]) {
          acc[date] = {
            reportDate: date,
            No_Of_Demand_By_Engg: 0,
            Engg_Demand: 0,
            No_Of_Demand_Agreed_GIVEN: 0,
            Agreed_Demand: 0,
            Availed_Not_Count: 0,
            Granted_Duration: 0,
            Availed: 0,
          };
        }

        acc[date].No_Of_Demand_By_Engg += num(item.No_Of_Demand_By_Engg);
        acc[date].Engg_Demand += Number(timeToSeconds(item?.Engg_Demand));
        acc[date].No_Of_Demand_Agreed_GIVEN += num(
          item.No_Of_Demand_Agreed_GIVEN
        );
        acc[date].Agreed_Demand += Number(timeToSeconds(item?.Agreed_Demand));
        acc[date].Availed += Number(timeToSeconds(item?.Availed));
        acc[date].Granted_Duration += Number(
          timeToSeconds(item?.Granted_Duration)
        );

        if (text(item.Availed_Not).includes("availed")) {
          acc[date].Availed_Not_Count += 1;
        }

        return acc;
      }, {});

      // Convert the grouped object to an array
      const result = Object.values(groupedTotals);
      setFinalData(result);
    }
  }, [data]);
  return (
    <div className="papaDiv">
      {/* <BlockReportMaster data={data} dataForTable={dataForTable} /> */}
      <BlockPositionChart data={data} dataForTable={dataForTable} />

      <div className="papaDiv">
        <div
          className="table-responsive"
          style={{ maxHeight: "750px", overflow: "auto" }}
        >
          <table
            ref={tableRef}
            className="table table-striped table-hover"
            // style={{ borderCollapse: "collapse" }}
          >
            <thead className=" sticky-top table-dark ">
              <tr className="align-middle border-white">
                <th rowSpan={2} className="  align-middle border-white">
                  Date
                </th>
                {tableHead.map((head, key) => {
                  if (
                    head === "Burst" ||
                    head === "Block Not Agreed" ||
                    head === "Cases of BABNG"
                  ) {
                    return (
                      <th key={key} rowSpan={2}>
                        {head}
                      </th>
                    );
                  }

                  return (
                    <th key={key} colSpan={2} className="border-white">
                      {head}
                    </th>
                  );
                })}
              </tr>
              <tr className="border-white">
                {tableSubHead.map((subHead, key) => {
                  return (
                    <th key={key} className="border-white">
                      {subHead}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {finalData &&
                data.length > 0 &&
                finalData.map((obj, key) => {
                  return (
                    <tr key={key}>
                      <td
                        style={{
                          background: "rgba(168, 168, 168, 0.7)",
                        }}
                      >
                        <b>{obj.reportDate}</b>
                      </td>
                      <td>{obj.No_Of_Demand_By_Engg}</td>
                      <td>{secondsToTime(obj.Engg_Demand)}</td>
                      <td>{obj.No_Of_Demand_Agreed_GIVEN}</td>{" "}
                      <td>{secondsToTime(obj.Agreed_Demand)}</td>
                      <td>{obj.No_Of_Demand_Agreed_GIVEN}</td>
                      <td>{secondsToTime(obj.Granted_Duration)}</td>
                      <td>{obj.No_Of_Demand_Agreed_GIVEN}</td>
                      <td>{secondsToTime(obj.Availed)}</td>
                      {/* /////////////// */}
                      <td>
                        {(
                          (obj.No_Of_Demand_Agreed_GIVEN * 100) /
                          obj.No_Of_Demand_By_Engg
                        ).toFixed(2)}
                      </td>
                      <td>
                        {(
                          (obj.Granted_Duration * 100) /
                          obj.Engg_Demand
                        ).toFixed(2)}
                      </td>
                      <td>
                        {secondsToTime(obj.Availed - obj.Granted_Duration)}
                      </td>
                      <td>
                        {obj.No_Of_Demand_Agreed_GIVEN -
                          obj.No_Of_Demand_By_Engg}
                      </td>
                      <td>
                        {obj.No_Of_Demand_Agreed_GIVEN -
                          obj.No_Of_Demand_Agreed_GIVEN}
                      </td>
                      {/* ///////////////////// */}
                    </tr>
                  );
                })}
            </tbody>
            <tfoot className="sticky-bottom">
              {/* Total row */}
              {finalData && data.length > 0 && (
                <tr className="fw-bold table-dark">
                  <td>Total</td>
                  <td>
                    {(finalData || []).reduce(
                      (acc, obj) => acc + (obj.No_Of_Demand_By_Engg || 0),
                      0
                    )}
                  </td>
                  <td>
                    {secondsToTime(
                      (finalData || []).reduce(
                        (acc, obj) => acc + (obj.Engg_Demand || 0),
                        0
                      )
                    )}
                  </td>
                  <td>
                    {(finalData || []).reduce(
                      (acc, obj) => acc + (obj.No_Of_Demand_Agreed_GIVEN || 0),
                      0
                    )}
                  </td>
                  <td>
                    {secondsToTime(
                      (finalData || []).reduce(
                        (acc, obj) => acc + (obj.Agreed_Demand || 0),
                        0
                      )
                    )}
                  </td>
                  <td>
                    {(finalData || []).reduce(
                      (acc, obj) => acc + (obj.No_Of_Demand_Agreed_GIVEN || 0),
                      0
                    )}
                  </td>
                  <td>
                    {secondsToTime(
                      (finalData || []).reduce(
                        (acc, obj) => acc + (obj.Granted_Duration || 0),
                        0
                      )
                    )}
                  </td>{" "}
                  <td>
                    {(finalData || []).reduce(
                      (acc, obj) => acc + (obj.No_Of_Demand_Agreed_GIVEN || 0),
                      0
                    )}
                  </td>
                  <td>
                    {secondsToTime(
                      (finalData || []).reduce(
                        (acc, obj) => acc + (obj.Availed || 0),
                        0
                      )
                    )}
                  </td>
                  {/* //////////////// */}
                  <td>
                    {" "}
                    {(
                      ((finalData || []).reduce(
                        (acc, obj) =>
                          acc + (obj.No_Of_Demand_Agreed_GIVEN || 0),
                        0
                      ) *
                        100) /
                      (finalData || []).reduce(
                        (acc, obj) => acc + (obj.No_Of_Demand_By_Engg || 0),
                        0
                      )
                    ).toFixed(2)}
                  </td>
                  <td>
                    {(
                      ((finalData || []).reduce(
                        (acc, obj) => acc + (obj.Granted_Duration || 0),
                        0
                      ) *
                        100) /
                      (finalData || []).reduce(
                        (acc, obj) => acc + (obj.Engg_Demand || 0),
                        0
                      )
                    ).toFixed(2)}
                  </td>
                  <td>
                    {" "}
                    {secondsToTime(
                      (finalData || []).reduce(
                        (acc, obj) => acc + (obj.Availed || 0),
                        0
                      ) -
                        (finalData || []).reduce(
                          (acc, obj) => acc + (obj.Granted_Duration || 0),
                          0
                        )
                    )}
                  </td>
                  <td>
                    {(finalData || []).reduce(
                      (acc, obj) => acc + (obj.No_Of_Demand_Agreed_GIVEN || 0),
                      0
                    ) -
                      (finalData || []).reduce(
                        (acc, obj) => acc + (obj.No_Of_Demand_By_Engg || 0),
                        0
                      )}
                  </td>
                  <td>
                    {(finalData || []).reduce(
                      (acc, obj) => acc + (obj.No_Of_Demand_Agreed_GIVEN || 0),
                      0
                    ) -
                      (finalData || []).reduce(
                        (acc, obj) =>
                          acc + (obj.No_Of_Demand_Agreed_GIVEN || 0),
                        0
                      )}
                  </td>
                </tr>
              )}
            </tfoot>
          </table>
        </div>
      </div>
      <DownloadExcel tableRef={tableRef} fileName={`Block Position `} />
    </div>
  );
};
export default BlockPositionMasterTable;
